/* MiniRoyals — vanilla JS interactions (no framework). */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Sticky header: expose announcement height so only the
     nav stays pinned (see #shopify-section-header rule in CSS) ---------- */
  function initStickyHeader(root) {
    var ann = root.querySelector('.mr-announce');
    function measure() {
      document.documentElement.style.setProperty('--mr-announce-h', (ann ? ann.offsetHeight : 0) + 'px');
    }
    measure();
    if (ann && window.ResizeObserver) new ResizeObserver(measure).observe(ann);
    else window.addEventListener('resize', measure);
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement(root) {
    var el = root.querySelector('[data-mr-announce-text]');
    if (!el) return;
    var items;
    try { items = JSON.parse(el.getAttribute('data-items') || '[]'); } catch (e) { items = []; }
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % items.length;
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
      el.textContent = items[i];
    }, 3600);
  }

  /* ---------- Hero carousel ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-mr-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-mr-slide]');
    var dots = root.querySelectorAll('[data-mr-dot]');
    var n = slides.length;
    if (n < 2) return;
    var idx = 0;
    var timer = null;

    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    function go(i) { idx = ((i % n) + n) % n; render(); }
    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () { go(idx + 1); }, 7000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.querySelectorAll('[data-mr-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(idx - 1); start(); });
    });
    root.querySelectorAll('[data-mr-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(idx + 1); start(); });
    });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    render();
    start();
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    var items = root.querySelectorAll('[data-mr-faq]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-mr-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var b = o.querySelector('[data-mr-faq-q]');
          if (b) b.setAttribute('aria-expanded', 'false');
          var s = o.querySelector('[data-mr-faq-sign]');
          if (s) s.textContent = '+';
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var sign = item.querySelector('[data-mr-faq-sign]');
          if (sign) sign.textContent = '–';
        }
      });
    });
  }

  /* ---------- Bundle selection (landing — visual ring only) ---------- */
  function initBundles(root) {
    var cards = root.querySelectorAll('[data-mr-bundle]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu(root) {
    var toggle = root.querySelector('[data-mr-menu-toggle]');
    var menu = root.querySelector('[data-mr-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.style.display === 'block';
      menu.style.display = open ? 'none' : 'block';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.style.display = 'none';
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- PDP (product page) controller ---------- */
  function mrUpdateCartCount() {
    var els = document.querySelectorAll('[data-mr-cart-count]');
    if (!els.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { els.forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  function initPdp(root) {
    // Pack rows and the sticky button are [data-mr-buy-now] links
    // (handled by initBuyNowLinks): one click -> that pack -> checkout.

    // gallery thumbnails
    var mainImg = root.querySelector('[data-mr-gallery-main]');
    var thumbs = root.querySelectorAll('[data-mr-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        var full = t.getAttribute('data-full');
        if (full) { mainImg.src = full; mainImg.srcset = ''; }
        thumbs.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-current', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-current', 'true');
      });
    });

    // sticky buy bar: show once the main add button scrolls out of view
    var sticky = root.querySelector('[data-mr-pp-sticky]');
    var anchor = root.querySelector('[data-mr-add-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* ---------- Tabs (details section) ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-mr-tab]');
    var panels = root.querySelectorAll('[data-mr-panel]');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  }

  /* ---------- Generic buy-now links (e.g. nav CTA) -> checkout ---------- */
  function initBuyNowLinks() {
    document.querySelectorAll('[data-mr-buy-now]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var vid = el.getAttribute('data-variant-id');
        if (!vid) return;
        e.preventDefault();
        el.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(vid), quantity: 1 })
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/cart/' + vid + ':1'; });
      });
    });
  }

  /* ---------- Cart page: steppers submit the update form ---------- */
  function initCartQty() {
    document.querySelectorAll('[data-mr-cart-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input || !input.form) return;
      var submit = function () {
        if (input.form.requestSubmit) input.form.requestSubmit();
        else input.form.submit();
      };
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.hasAttribute('data-inc') ? 1 : -1;
          input.value = Math.max(0, Number(input.value || 0) + delta);
          submit();
        });
      });
      input.addEventListener('change', submit);
    });
  }

  /* ---------- Parallax for decorative side characters ---------- */
  /* ---------- Mix-and-match combo card ---------- */
  function initComboBuilder() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-mr-combo]'));
    cards.forEach(function (card) {
      var variants;
      try { variants = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (err) { return; }
      if (!variants.length) return;
      var labelA = card.getAttribute('data-flavor-a') || 'Chocolate';
      var labelB = card.getAttribute('data-flavor-b') || 'Fresa';

      function countOf(title, label) {
        var m = title.match(new RegExp('(\\d+)\\s*' + label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'));
        return m ? parseInt(m[1], 10) : 0;
      }
      function money(cents) {
        var s = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
        return '$ ' + s.replace(/\.00$/, '');
      }

      var priceEl = card.querySelector('[data-mr-combo-price]');
      var wasEl = card.querySelector('[data-mr-combo-was]');
      var cta = card.querySelector('[data-mr-combo-cta]');
      var hint = card.querySelector('[data-mr-combo-hint]');
      var imgsEl = card.querySelector('[data-mr-combo-imgs]');
      var imgSrc = { a: card.getAttribute('data-img-a'), b: card.getAttribute('data-img-b') };
      var qtyEls = { a: card.querySelector('[data-mr-combo-qty="a"]'), b: card.querySelector('[data-mr-combo-qty="b"]') };
      var stepBtns = {
        aMinus: card.querySelector('[data-mr-combo-step="a:-1"]'),
        aPlus: card.querySelector('[data-mr-combo-step="a:1"]'),
        bMinus: card.querySelector('[data-mr-combo-step="b:-1"]'),
        bPlus: card.querySelector('[data-mr-combo-step="b:1"]')
      };

      // Bounds derived from the variants themselves: with a per-flavor minimum
      // and a max total, every reachable stepper state is a real variant.
      var minA = Infinity, minB = Infinity, maxTotal = 0;
      variants.forEach(function (v) {
        var a = countOf(v.title, labelA);
        var b = countOf(v.title, labelB);
        minA = Math.min(minA, a);
        minB = Math.min(minB, b);
        maxTotal = Math.max(maxTotal, a + b);
      });

      var qty = { a: 0, b: 0 };
      var start = variants[0];
      qty.a = countOf(start.title, labelA);
      qty.b = countOf(start.title, labelB);

      function match() {
        for (var i = 0; i < variants.length; i++) {
          if (countOf(variants[i].title, labelA) === qty.a && countOf(variants[i].title, labelB) === qty.b) return variants[i];
        }
        return null;
      }
      function render() {
        qtyEls.a.textContent = qty.a;
        qtyEls.b.textContent = qty.b;
        var total = qty.a + qty.b;
        if (stepBtns.aMinus) stepBtns.aMinus.disabled = qty.a <= minA;
        if (stepBtns.bMinus) stepBtns.bMinus.disabled = qty.b <= minB;
        if (stepBtns.aPlus) stepBtns.aPlus.disabled = total >= maxTotal;
        if (stepBtns.bPlus) stepBtns.bPlus.disabled = total >= maxTotal;
        if (imgsEl) {
          var html = '';
          var i;
          for (i = 0; i < qty.a; i++) html += '<img src="' + imgSrc.a + '" alt="" width="64" height="64" loading="lazy">';
          for (i = 0; i < qty.b; i++) html += '<img src="' + imgSrc.b + '" alt="" width="64" height="64" loading="lazy">';
          imgsEl.innerHTML = html;
        }
        var v = match();
        if (v && v.available) {
          priceEl.textContent = money(v.price);
          if (v.cap && v.cap > v.price) { wasEl.textContent = money(v.cap); wasEl.hidden = false; } else { wasEl.hidden = true; }
          cta.setAttribute('href', '/cart/' + v.id + ':1');
          cta.setAttribute('data-variant-id', v.id);
          cta.classList.remove('is-disabled');
          cta.removeAttribute('aria-disabled');
          if (hint) hint.hidden = true;
        } else {
          priceEl.textContent = '—';
          wasEl.hidden = true;
          cta.setAttribute('href', '#');
          cta.removeAttribute('data-variant-id');
          cta.classList.add('is-disabled');
          cta.setAttribute('aria-disabled', 'true');
          if (hint) hint.hidden = false;
        }
      }
      card.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mr-combo-step]');
        if (!btn) return;
        var parts = btn.getAttribute('data-mr-combo-step').split(':');
        var key = parts[0];
        var delta = parseInt(parts[1], 10);
        var next = qty[key] + delta;
        var min = key === 'a' ? minA : minB;
        var otherMin = key === 'a' ? minB : minA;
        next = Math.max(min, Math.min(maxTotal - otherMin, next));
        var other = key === 'a' ? qty.b : qty.a;
        if (next + other > maxTotal) next = maxTotal - other;
        qty[key] = next;
        render();
      });
      render();
    });
  }

  /* ---------- Header submenu (touch/keyboard toggle) ---------- */
  function initNavDropdowns() {
    var groups = Array.prototype.slice.call(document.querySelectorAll('.mr-nav__group'));
    if (!groups.length) return;
    groups.forEach(function (g) {
      var btn = g.querySelector('.mr-nav__group-btn');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = g.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function () {
      groups.forEach(function (g) {
        g.classList.remove('is-open');
        var btn = g.querySelector('.mr-nav__group-btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        groups.forEach(function (g) { g.classList.remove('is-open'); });
      }
    });
  }

  /* ---------- Flavor tabs on the bundles grid ---------- */
  function initFlavorTabs() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-mr-flavor-tabs]'));
    bars.forEach(function (bar) {
      var sec = bar.closest('.mr-bundles-sec');
      if (!sec) return;
      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mr-flavor-tab]');
        if (!btn) return;
        var flavor = btn.getAttribute('data-mr-flavor-tab');
        Array.prototype.forEach.call(bar.querySelectorAll('[data-mr-flavor-tab]'), function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(sec.querySelectorAll('[data-mr-bundle]'), function (card) {
          var f = card.getAttribute('data-flavor') || '';
          card.classList.toggle('is-flavor-hidden', f !== '' && f !== flavor);
        });
      });
    });
  }

  function initParallax() {
    if (reduceMotion) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-mr-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      els.forEach(function (el) {
        var host = el.parentElement;
        if (!host) return;
        var r = host.getBoundingClientRect();
        var f = parseFloat(el.getAttribute('data-mr-parallax')) || 0;
        var d = ((r.top + r.height / 2) - (vh / 2)) * f;
        d = Math.max(-30, Math.min(30, d));
        el.style.transform = 'translateY(' + d.toFixed(1) + 'px)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- boot ---------- */
  function boot() {
    document.querySelectorAll('[data-mr-header]').forEach(initMobileMenu);
    document.querySelectorAll('[data-mr-header]').forEach(initAnnouncement);
    document.querySelectorAll('[data-mr-header]').forEach(initStickyHeader);
    document.querySelectorAll('[data-mr-hero]').forEach(initCarousel);
    document.querySelectorAll('[data-mr-faqs]').forEach(initFaq);
    document.querySelectorAll('[data-mr-bundles]').forEach(initBundles);
    document.querySelectorAll('[data-mr-pdp]').forEach(initPdp);
    document.querySelectorAll('[data-mr-tabs]').forEach(initTabs);
    initBuyNowLinks();
    initCartQty();
    initParallax();
    initFlavorTabs();
    initComboBuilder();
    initNavDropdowns();
    mrUpdateCartCount();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
